import type { ImeiHubServiceId } from '../components/ImeiHubSignalIcon'

/** Hub service that can fill in an unverified report row (IMEI.EU hub cards). */
export const CHECK_TO_HUB_SERVICE: Record<string, ImeiHubServiceId> = {
  imei: 'verify',
  device: 'passport',
  blacklist: 'safecheck',
  carrier: 'carrier',
  lock: 'lock',
  finance: 'safecheck',
  mdm: 'business',
  android: 'android',
}

/** Icon for a report check row — same Phosphor mapping as IMEI hub service tiles. */
export function hubServiceForCheckIcon(checkId: string): ImeiHubServiceId {
  return CHECK_TO_HUB_SERVICE[checkId] ?? 'verify'
}

export function followUpHubServiceForCheck(
  checkId: string,
  currentService: ImeiHubServiceId,
): ImeiHubServiceId | null {
  const target = CHECK_TO_HUB_SERVICE[checkId]
  if (!target) return null
  if (target === currentService) return null
  return target
}
